import { maxLength } from '@carboledger/ui';
import { emailRule, referenceIdNumberRule } from '@/lib/validation';
import { getTranslation } from '@/lib/utils/i18n';
import { ORGANIZATION_NAME_MAX_LENGTH } from './constants/suppliers.constants';

// Format rules for the supplier form; `required` lives on each <Field>.
export const supplierValidation = {
  organizationName: [
    maxLength(
      ORGANIZATION_NAME_MAX_LENGTH,
      getTranslation('VALIDATION_MAX_LENGTH', { max: ORGANIZATION_NAME_MAX_LENGTH }),
    ),
  ],
  supplierId: referenceIdNumberRule,
  email: emailRule,
};
